export const BREAKPOINTS: {
  [key: string]: number;
} = {
  mobileS: 320,
  mobileM: 405,
  mobileL: 425,
  mobileXL: 530,
  tabletS: 780,
  tablet: 844,
  laptop: 1047,
  laptopL: 1440,
  desktop: 2560,
};
